import './statuses.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Checkbox from '../../../../shared/form-elements/checkbox';

const Main = props =>
	<div className="params-form statuses-form">
		<span className="title">{props.intl('Affiliate statuses')}</span>
		<form
			action="#"
			onSubmit={e => {
				e.preventDefault();
			}}
		>
			<Field name="new" placeholder={props.intl('New')} component={Checkbox} />
			<Field name="prospect" placeholder={props.intl('Prospect')} component={Checkbox} />
			<Field name="active" placeholder={props.intl('Active')} component={Checkbox} />
			<Field name="inactive" placeholder={props.intl('Inactive')} component={Checkbox} />
			<Field name="archived" placeholder={props.intl('Archived')} component={Checkbox} />
		</form>
	</div>;

Main.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({
	form: 'affiliateProfileAffiliateTabStatusesForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/affiliates/statuses.js